import styled from "styled-components";

import { ArrowBack as MuiArrowBack } from "@mui/icons-material";
import {
  IconButton as MuiIconButton,
  Tab as MuiTab,
  Tabs as MuiTabs,
} from "@mui/material";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  /* border-bottom: 1px solid #e0e0e0; */
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
`;

export const Flex = styled.header`
  width: 100%;
  max-width: 1366px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const Main = styled.div`
  width: 100%;
  max-width: 1366px;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  margin-top: 24px;
  border-radius: 8px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 100px;
`;

export const Heading = styled.h1`
  color: #191c1a;
  /* font-family: Sora; */
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  /* font-size: 1.5rem; */
`;

export const Tabs = styled(MuiTabs)``;
export const Tab = styled(MuiTab)``;
export const ArrowBack = styled(MuiArrowBack)`
  width: 24px;
  height: 24px;
`;
export const IconButton = styled(MuiIconButton)`
  margin-bottom: 2px;
`;
